<template>
  <v-layout wrap>
    <v-flex xs12 pt-2 pr-2>
      <v-card class="elevation-5">
        <v-card-text>
          <v-layout class="drag_layout">
            <v-flex xs12 sm6 md3 v-for="column in data" class="drag_culumn">
              <h3 class="drag_culumn__title">{{ column.name }}</h3>
              <draggable
                class="list-group elevation-3"
                :list="column.tasks"
                group="people"
                @change="moveTask($event, column)"
              >
                <v-card
                  class="list-group-item task-column__item"
                  v-for="task in column.tasks"
                  :key="task.id"
                  :to="{ name: 'tasks-form', params: {project_id: task.project_id, task_id: task.id }}"
                >
                  <div class="d-flex align-start justify-space-between wrap">
                    <div class="tasks_page__list--item_chip tasks_page__column--item_chip">
                      {{ task.short_name.toUpperCase() }}
                    </div>
                    <v-spacer />
                    <div
                      v-if="task.instance_users && task.instance_users.length"
                      class="tasks_page__column--users"
                    >
                      <div
                        v-for="user in task.instance_users"
                        :title="user.name"
                        :key="user.name"
                      >
                        {{ user.short_name }}
                      </div>
                    </div>
                  </div>
                  <v-card-text class="pa-1">
                    {{ task.title }}
                  </v-card-text>

                  <template v-if="task.labels && task.labels.length">
                    <v-divider class="mb-1"></v-divider>
                    <div class="d-flex tasks_page__column--labels pa-1">
                      <div
                          v-for="label in task.labels"
                          :key="label.name"
                          class="tasks_page__list--item_chip tasks_page__column--label"
                          :style="{ color: label.text_color, 'background-color': label.color}"
                      >
                        {{ label.name }}
                      </div>
                    </div>
                  </template>
                </v-card>
              </draggable>
            </v-flex>
          </v-layout>
        </v-card-text>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import * as mixins from '@/mixins/'

  export default {
    name: 'TasksColumn',
    mixins: [mixins.draggable],
    props: ['data'],
    data() {
      return {
        currentTask: {},
        isDragging: true,
        timesColumns: [],
        list: []
      }
    },
    methods: {
      refresh() {
        this.$emit('refresh')
      },
      moveTask(event, column) {
        if (event.added) {
          this.list = this.list.map(item => {
            if (event.added.element.id == item.id) {
              item.column_id = column.id
            }
            return item
          })
          let data = {...event.added.element, column_id: column.id}

          this.$api.tasks.save(data).then(() => {
            this.$notify({
              group: 'success',
              type: 'success',
              text: 'Value changed'
            })
          }, () => {
            this.$emit('refresh')
          })
        }
      },
    },
    watch: {
      tasks(value) {
        this.list = value
      },
    }
  }
</script>

<style lang="stylus">
@import '../../scss/_varaibles';
  ease-out = all 0.3s cubic-bezier(0.23, 1, 0.32, 1);
  .flip-list-move {
    transition: transform 0.5s;
  }

  .drag_layout {
    overflow: auto;
  }

  .drag_culumn {
    min-width: 300px;
    overflow: auto;
  }

  .drag-list {
    display: flex;
    align-items: flex-start;

    @media (max-width: 690px) {
      display: block;
    }
  }

  .list-group {
    flex: 1;
    background: secondary;
    min-height: calc(100vh - 280px);
    max-height: calc(100vh - 280px);
    overflow: auto;
    border-radius: 6px;

    @media (max-width: 690px) {
      margin-bottom: 30px;
    }

    h2 {
      font-size: 0.8rem;
      margin: 0;
      text-transform: uppercase;
      font-weight: 600;
    }

  }

  .drag_culumn__title {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    padding: 0 0 10px;
    white-space: nowrap;
    user-select: none;
  }

  .drag-inner-list {
    height: 85vh;
    overflow: auto;
  }

  .list-group-item {
    margin: 10px;
    height: 100px;
    background: #fff;
    border-radius: 6px !important;
    cursor: pointer;
    transition: $ease-out;

    &:hover {
      background: rgba(88, 203, 183, 0.3) !important;
    }

    /* items grabbed state */
    &.sortable-chosen {
      background: #5cc1a6;
      color: #fff;
    }

    .drag-item-text {
      font-size: 1rem;
      padding-left: 1rem;
      padding-top: 1rem;
    }
  }

  .drag-header-more {
    cursor: pointer;
  }

  @keyframes nodeInserted {
    from {
      opacity: 0.2;
    }
    to {
      opacity: 0.8;
    }
  }

  .item-dropzone-area {
    height: 6rem;
    background: #888;
    opacity: 0.8;
    animation-duration: 0.5s;
    animation-name: nodeInserted;
    margin-left: 0.6rem;
    margin-right: 0.6rem;
  }
</style>
